import { useState, useEffect } from 'react';

export default function NextEvent() {
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/api/next-event', {
      headers: { 'X-API-Key': import.meta.env.VITE_API_KEY || '' }
    })
      .then(res => {
        if (res.status === 404) return res.json().then(d => { throw new Error(d.message || 'No upcoming events'); });
        if (!res.ok) throw new Error('Failed to load event data');
        return res.json();
      })
      .then(data => { setEvent(data); setLoading(false); })
      .catch(err => { setError(err.message); setLoading(false); });
  }, []);

  const formatDate = (iso) =>
    new Date(iso).toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });

  return (
    <div className="App">
      <header className="App-header">
        <h1>🏍️ NHCA — Next Event</h1>
      </header>

      <main className="App-main" style={{ maxWidth: 600, margin: '0 auto', padding: '2rem 1rem' }}>
        {loading && (
          <div className="loading">
            <div className="spinner"></div>
            <p>Loading event info...</p>
          </div>
        )}

        {error && (
          <div className="error-message">
            <h3>⚠️ {error}</h3>
          </div>
        )}

        {event && (
          <div className="next-event-card">
            <div className="next-event-card-header">
              <span className="next-event-card-icon">📅</span>
              <h2 className="next-event-card-title">Next Event</h2>
            </div>

            <div className="next-event-card-body">
              <div className="next-event-card-hill">{event.displayHill}</div>
              {event.event_name && (
                <div className="next-event-card-name">{event.event_name}</div>
              )}
              {event.date && (
                <div className="next-event-card-date">{formatDate(event.date)}</div>
              )}

              <div className="next-event-card-countdown">
                <span className="countdown-number">{event.daysUntil}</span>
                <span className="countdown-label">{event.daysUntil === 1 ? 'day' : 'days'} to go</span>
              </div>

              {event.closingDate && event.daysUntilClosing !== null && (
                <div className={`next-event-card-closing ${event.daysUntilClosing <= 0 ? 'entry-closed' : event.daysUntilClosing <= 7 ? 'closing-soon' : ''}`}>
                  {event.daysUntilClosing > 0 && (
                    <>Entry closes in <strong>{event.daysUntilClosing} {event.daysUntilClosing === 1 ? 'day' : 'days'}</strong></>
                  )}
                  {event.daysUntilClosing === 0 && (
                    <strong>Entry closes today!</strong>
                  )}
                  {event.daysUntilClosing < 0 && (
                    <>Entry closed {Math.abs(event.daysUntilClosing)} {Math.abs(event.daysUntilClosing) === 1 ? 'day' : 'days'} ago</>
                  )}
                </div>
              )}
            </div>

            {event.otherClosingSoon && event.otherClosingSoon.length > 0 && (
              <div className="next-event-card-other">
                <div className="next-event-card-other-label">Also closing soon:</div>
                {event.otherClosingSoon.map((e, i) => (
                  <div key={i} className="next-event-card-other-item">
                    <strong>{e.hill}</strong> — closes in {e.daysUntilClosing} {e.daysUntilClosing === 1 ? 'day' : 'days'}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </main>

      <footer className="App-footer">
        <p>NHCA Hillclimb | Data updated in real-time</p>
      </footer>
    </div>
  );
}
